// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppShell_container__AAXxs {
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100vw;
  padding: 5rem;
}
@media only screen and (max-width: 37.5em) {
  .AppShell_container__AAXxs {
    padding: 3rem 2rem;
  }
}

.AppShell_appright__wkNYh {
  box-sizing: border-box;
  padding: 3rem 3rem;
  width: 80vw;
}
@media only screen and (max-width: 62.5em) {
  .AppShell_appright__wkNYh {
    width: 90%;
  }
}
@media only screen and (max-width: 50em) {
  .AppShell_appright__wkNYh {
    width: 100%;
  }
}

.AppShell_topside__xQn78 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.AppShell_topside_left__s4m5U {
  display: flex;
  align-items: center;
}
.AppShell_topside_left__s4m5U > :not(:last-child) {
  margin-right: 2rem;
}
.AppShell_topside_1__LwDMi {
  display: flex;
  align-items: center;
}
.AppShell_topside_1__LwDMi > :not(:last-child) {
  margin-right: 3rem;
}
.AppShell_topside_welcome__MDmN9 {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.AppShell_topside_name__Usmkj {
  color: var(--color-primary);
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  line-height: 3rem;
}
.AppShell_topside_icon__B04k8 {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .AppShell_topside_icon__B04k8 {
    margin-bottom: 1rem;
  }
}
.AppShell_topside__xQn78 h3 {
  font-size: var(--default-font-h3);
  line-height: 3.6rem;
}
@media only screen and (max-width: 37.5em) {
  .AppShell_topside__xQn78 h3 {
    font-size: var(--default-font-subtitle);
  }
}

.AppShell_menuIcon__QQDCA {
  font-size: 3rem;
  color: var(--color-fash-black);
  cursor: pointer;
}
.AppShell_menuIcon__QQDCA:focus, .AppShell_menuIcon__QQDCA:hover {
  color: var(--color-fash-primary-2);
}

.AppShell_mobileSidebar__Re8LH {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 70vw 30vw;
  z-index: 100;
}

.AppShell_sidebar__R2VP1 {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 30vw 70vw;
  z-index: 100;
  top: 0;
  left: 0;
}
.AppShell_sidebar__R2VP1 > :nth-child(2) {
  cursor: pointer;
}
@media only screen and (max-width: 50em) {
  .AppShell_sidebar__R2VP1 {
    grid-template-columns: 40vw 60vw;
  }
}
@media only screen and (max-width: 37.5em) {
  .AppShell_sidebar__R2VP1 {
    grid-template-columns: 70vw 30vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Components/AppShell.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AADJ;AAGI;EAPJ;IAQQ,kBAAA;EAAN;AACF;;AAGA;EACI,sBAAA;EACA,kBAAA;EACA,WAAA;AAAJ;AAEI;EALJ;IAMQ,UAAA;EACN;AACF;AACI;EATJ;IAUQ,WAAA;EAEN;AACF;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AAEI;EACI,aAAA;EACA,mBAAA;AAAR;AAEQ;EACI,kBAAA;AAAZ;AAII;EACI,aAAA;EACA,mBAAA;AAFR;AAIQ;EACI,kBAAA;AAFZ;AAMI;EACI,oCAAA;EACA,mBAAA;AAJR;AAOI;EACI,2BAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AALR;AAQI;EACI,aAAA;EACA,mBAAA;AANR;AAQQ;EAJJ;IAKQ,mBAAA;EALV;AACF;AASI;EACI,iCAAA;EACA,mBAAA;AAPR;AASQ;EAJJ;IAKQ,uCAAA;EANV;AACF;;AAUA;EACI,eAAA;EACA,8BAAA;EACA,eAAA;AAPJ;AASI;EAEI,kCAAA;AARR;;AAYA;EACI,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AATJ;;AAYA;EACI,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AATJ;AAWI;EACI,eAAA;AATR;AAYI;EAfJ;IAgBQ,gCAAA;EATN;AACF;AAWI;EAnBJ;IAoBQ,gCAAA;EARN;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    max-width: 100vw;\n    padding: 5rem;\n\n    @media only screen and (max-width: $bp-600) {\n        padding: 3rem 2rem;\n    }\n}\n\n.appright {\n    box-sizing: border-box;\n    padding: 3rem 3rem;\n    width: 80vw;\n\n    @media only screen and (max-width: $bp-1000) {\n        width: 90%;\n    }\n\n    @media only screen and (max-width: $bp-800) {\n        width: 100%;\n    }\n\n\n}\n\n.topside {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n\n    &_left {\n        display: flex;\n        align-items: center;\n\n        &> :not(:last-child) {\n            margin-right: 2rem;\n        }\n    }\n\n    &_1 {\n        display: flex;\n        align-items: center;\n\n        &> :not(:last-child) {\n            margin-right: 3rem;\n        }\n    }\n\n    &_welcome {\n        font-size: var(--default-font-small);\n        line-height: 1.8rem;\n    }\n\n    &_name {\n        color: var(--color-primary);\n        font-size: var(--default-font-subtitle);\n        font-weight: 700;\n        line-height: 3rem;\n    }\n\n    &_icon {\n        display: flex;\n        align-items: center;\n\n        @media only screen and (max-width: $bp-500) {\n            margin-bottom: 1rem;\n        }\n    }\n\n\n    h3 {\n        font-size: var(--default-font-h3);\n        line-height: 3.6rem;\n\n        @media only screen and (max-width: $bp-600) {\n            font-size: var(--default-font-subtitle);\n        }\n    }\n}\n\n.menuIcon {\n    font-size: 3rem;\n    color: var(--color-fash-black);\n    cursor: pointer;\n\n    &:focus,\n    &:hover {\n        color: var(--color-fash-primary-2);\n    }\n}\n\n.mobileSidebar {\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(#2a2828, 0.7);\n    position: fixed;\n    display: grid;\n    grid-template-columns: 70vw 30vw;\n    z-index: 100;\n}\n\n.sidebar {\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(#2a2828, 0.7);\n    position: fixed;\n    display: grid;\n    grid-template-columns: 30vw 70vw;\n    z-index: 100;\n    top: 0;\n    left: 0;\n\n    &> :nth-child(2) {\n        cursor: pointer;\n    }\n\n    @media only screen and (max-width: $bp-medium) {\n        grid-template-columns: 40vw 60vw;\n    }\n\n    @media only screen and (max-width: $bp-small) {\n        grid-template-columns: 70vw 30vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AppShell_container__AAXxs`,
	"appright": `AppShell_appright__wkNYh`,
	"topside": `AppShell_topside__xQn78`,
	"topside_left": `AppShell_topside_left__s4m5U`,
	"topside_1": `AppShell_topside_1__LwDMi`,
	"topside_welcome": `AppShell_topside_welcome__MDmN9`,
	"topside_name": `AppShell_topside_name__Usmkj`,
	"topside_icon": `AppShell_topside_icon__B04k8`,
	"menuIcon": `AppShell_menuIcon__QQDCA`,
	"mobileSidebar": `AppShell_mobileSidebar__Re8LH`,
	"sidebar": `AppShell_sidebar__R2VP1`
};
export default ___CSS_LOADER_EXPORT___;
